module.exports = __webpack_public_path__ + "img/camara.097f0502.svg";